import request from './request'

export function fetchPlayerLevels() {
  return request({ url: '/api/player-levels', method: 'get' })
}

export function deletePlayerLevel(id) {
  return request({ url: `/api/player-levels/${encodeURIComponent(id)}`, method: 'delete' })
}

/** 玩家上传原图预览（data URL） */
export function fetchPlayerLevelPreview(id) {
  return request({
    url: `/api/player-levels/${encodeURIComponent(id)}/preview`,
    method: 'get'
  })
}
